import React, { useState, useEffect } from "react";
import {
    AppBar,
    Box,
    Container,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Toolbar,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import DescriptionIcon from "@mui/icons-material/Description";
import RuleIcon from "@mui/icons-material/Rule";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PostAddIcon from "@mui/icons-material/PostAdd";
import LogoutIcon from "@mui/icons-material/Logout";
import DomainIcon from "@mui/icons-material/Domain";
import YouTubeIcon from "@mui/icons-material/YouTube";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InboxIcon from "@mui/icons-material/Inbox";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext";
import CommentIcon from "@mui/icons-material/Comment";
import AddCommentIcon from "@mui/icons-material/AddComment";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

function Header() {
    const headerImage = process.env.PUBLIC_URL + "/images/logo.png";

    const auth = getAuth();
    const navigate = useNavigate();

    const [login, setLogin] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClickClose = () => {
        setOpen(false);
    };
    const [isDrawerOpen, setOpen] = useState(false);

    const transHome = () => {
        window.open("https://trpg-sog.com", "_blank", "noopener,noreferrer");
    };

    const transYoutube = () => {
        window.open("https://youtube.com", "_blank", "noopener,noreferrer");
    };

    const transPixiv = () => {
        window.open("https://www.pixiv.net/", "_blank", "noopener,noreferrer");
    };

    const transFanbox = () => {
        window.open("https://www.fanbox.cc/", "_blank", "noopener,noreferrer");
    };

    const transBooth = () => {
        window.open("https://booth.pm/ja", "_blank", "noopener,noreferrer");
    };

    const handleLogout = () => {
        signOut(auth);
        setOpen(false);

        window.scrollTo(0, 0);
        window.location.href = "/login";
    };

    useEffect(() => {
        const unsubscribed = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                setLogin(true);
            } else {
                setLogin(false);
            }
        });
        return () => unsubscribed();
    }, []);

    return (
        <>
            <AppBar>
                <Container
                    maxWidth="1280"
                    sx={{
                        display: { xs: { maxWidth: 0 } },
                        maxWidth: 1280,
                    }}
                    disableGutters
                >
                    <Toolbar>
                        <Box sx={{ flexGrow: 1 }} style={{ display: "flex", alignItem: "center" }}>
                            <img
                                src={headerImage}
                                alt="最強絶頂集団"
                                height={40}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/");
                                }}
                            />
                        </Box>

                        {login && (
                            <IconButton onClick={handleClickOpen}>
                                <MenuIcon fontSize="large" sx={{ color: "#fff" }} />
                            </IconButton>
                        )}
                    </Toolbar>
                </Container>
            </AppBar>

            <Drawer anchor="right" open={isDrawerOpen} onClose={handleClickClose}>
                <Box sx={{ width: 260, maxWidth: 260 }}>
                    <List>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <HomeIcon />
                                </ListItemIcon>
                                <ListItemText primary="TOP" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/mylist");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <RecentActorsIcon />
                                </ListItemIcon>
                                <ListItemText primary="マイリスト" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/character");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <PeopleAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="キャラクターリスト" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/scenario");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <DescriptionIcon />
                                </ListItemIcon>
                                <ListItemText primary="シナリオリスト" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/video");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <OndemandVideoIcon />
                                </ListItemIcon>
                                <ListItemText primary="動画リスト" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/info");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <CommentIcon />
                                </ListItemIcon>
                                <ListItemText primary="お知らせ" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/house-rule");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <RuleIcon />
                                </ListItemIcon>
                                <ListItemText primary="ハウスルール" />
                            </ListItemButton>
                        </ListItem>
                    </List>

                    <Divider />

                    <List>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/character-create");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <PersonAddAlt1Icon />
                                </ListItemIcon>
                                <ListItemText primary="キャラクター作成" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/scenario-create");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <PostAddIcon />
                                </ListItemIcon>
                                <ListItemText primary="シナリオ作成" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/video-create");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <QueuePlayNextIcon />
                                </ListItemIcon>
                                <ListItemText primary="動画リンク作成" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/info-create");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <AddCommentIcon />
                                </ListItemIcon>
                                <ListItemText primary="お知らせ作成" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    setOpen(false);
                                    window.scrollTo(0, 0);
                                    navigate("/house-rule-create");
                                }}
                                sx={{ "&:hover": { color: "inherit" } }}
                            >
                                <ListItemIcon>
                                    <PlaylistAddIcon />
                                </ListItemIcon>
                                <ListItemText primary="ハウスルール作成" />
                            </ListItemButton>
                        </ListItem>
                    </List>

                    <Divider />

                    <List>
                        <ListItem disablePadding>
                            <ListItemButton onClick={transHome} target="_blank" sx={{ "&:hover": { color: "inherit" } }} disabled>
                                <ListItemIcon>
                                    <DomainIcon />
                                </ListItemIcon>
                                <ListItemText primary="ホームページ" />
                                <ListItemSecondaryAction>
                                    <IconButton disableRipple size="small">
                                        <OpenInNewIcon fontSize="inherit" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={transYoutube} sx={{ "&:hover": { color: "inherit" } }} disabled>
                                <ListItemIcon>
                                    <YouTubeIcon />
                                </ListItemIcon>
                                <ListItemText primary="YouTube" />
                                <ListItemSecondaryAction>
                                    <IconButton disableRipple size="small">
                                        <OpenInNewIcon fontSize="inherit" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={transPixiv} sx={{ "&:hover": { color: "inherit" } }} disabled>
                                <ListItemIcon>
                                    <AssignmentIcon />
                                </ListItemIcon>
                                <ListItemText primary="Pixiv" />
                                <ListItemSecondaryAction>
                                    <IconButton disableRipple size="small">
                                        <OpenInNewIcon fontSize="inherit" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={transFanbox} sx={{ "&:hover": { color: "inherit" } }} disabled>
                                <ListItemIcon>
                                    <InboxIcon />
                                </ListItemIcon>
                                <ListItemText primary="FANBOX" />
                                <ListItemSecondaryAction>
                                    <IconButton disableRipple size="small">
                                        <OpenInNewIcon fontSize="inherit" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton onClick={transBooth} sx={{ "&:hover": { color: "inherit" } }} disabled>
                                <ListItemIcon>
                                    <LocalMallIcon />
                                </ListItemIcon>
                                <ListItemText primary="BOOTH" />
                                <ListItemSecondaryAction>
                                    <IconButton disableRipple size="small">
                                        <OpenInNewIcon fontSize="inherit" />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItemButton>
                        </ListItem>
                    </List>

                    <Divider />

                    <List>
                        <ListItem disablePadding>
                            <ListItemButton sx={{ "&:hover": { color: "inherit" } }} onClick={handleLogout}>
                                <ListItemIcon>
                                    <LogoutIcon />
                                </ListItemIcon>
                                <ListItemText primary="ログアウト" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </>
    );
}

export default Header;
